<template>
  <section>
    <validation-observer ref="semesterForm" #default="{ invalid }">
      <b-form @submit.prevent="semesterForm" v-if="!loading">
        <b-row>
          <b-col cols="12" xl="9" md="8">
            <b-card>
              <b-row>
                <b-col cols="12" md="6">
                  <b-form-group
                    label=" * نام ترم"
                    label-for="add-semester-name"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="name"
                      vid="name"
                      rules="required"
                    >
                      <b-form-input
                        autocomplete="on"
                        id="add-semester-name"
                        v-model="semester.name"
                        name="add-semester-name"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <div class="d-flex justify-content-between flex-wrap">
                    <b-form-group
                      label="تاریخ شروع ثبت نام ترم"
                      label-for="add-semester-available-at"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="available-at"
                        vid="available-at"
                      >
                        <date-picker
                          v-model="semester.available_at"
                          autocomplete="on"
                          id="add-semester-available-at"
                          type="datetime"
                          clearable
                          name="add-semester-available-at"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                    <b-form-group
                      label="تاریخ پایان ثبت نام ترم"
                      label-for="add-semester-unavailable-at"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="unavailable-at"
                        vid="unavailable-at"
                      >
                        <date-picker
                          class="mb-0"
                          v-model="semester.unavailable_at"
                          autocomplete="on"
                          id="add-semester-unavailable-at"
                          type="datetime"
                          name="add-semester-unavailable-at"
                          clearable
                        />

                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </div>
                  <div class="d-flex justify-content-between flex-wrap">
                    <b-form-group
                      label="تاریخ شروع ترم"
                      label-for="add-semester-started-at"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="started-at"
                        vid="started-at"
                      >
                        <date-picker
                          v-model="semester.started_at"
                          autocomplete="on"
                          id="add-semester-started-at"
                          type="datetime"
                          clearable
                          name="add-semester-started-at"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                    <b-form-group
                      label="تاریخ پایان ترم"
                      label-for="add-semester-ended-at"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="ended-at"
                        vid="ended-at"
                      >
                        <date-picker
                          class="mb-0"
                          v-model="semester.ended_at"
                          autocomplete="on"
                          id="add-semester-ended-at"
                          type="datetime"
                          name="add-semester-ended-at"
                          clearable
                        />

                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </div>
                  <div class="d-flex">
                    <b-form-group label-for="add-semester-active" class="w-50">
                      <b-form-checkbox
                        v-model="semester.active"
                        name="check-active"
                        switch
                        inline
                        :uncheckedValue="0"
                        :value="1"
                      >
                        وضعیت ترم
                      </b-form-checkbox>
                    </b-form-group>
                    <b-form-group
                      label-for="add-semester-default"
                      class="w-50 pl-1"
                    >
                      <b-form-checkbox
                        v-model="semester.default"
                        name="check-default"
                        switch
                        inline
                        :uncheckedValue="0"
                        :value="1"
                      >
                        ترم پیش فرض
                      </b-form-checkbox>
                    </b-form-group>
                  </div>
                  <roadmaps
                    :propRoadmaps="semester.roadmaps"
                    v-model="semester.roadmaps"
                  />
                </b-col>
                <b-col cols="12" md="6">
                  <b-form-checkbox
                    v-model="penalty"
                    name="check-penalty"
                    switch
                    inline
                    class="my-2 pb-50"
                    :uncheckedValue="0"
                    :value="1"
                  >
                    محاسبه جریمه
                  </b-form-checkbox>
                  <b-form-group
                    label=" * بازه جریمه (دقیقه)"
                    label-for="add-semester-penalty_duration"
                    class="mb-1"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="penalty_duration"
                      vid="penalty_duration"
                      :rules="semester.penalty != 0 ? 'required' : ''"
                    >
                      <b-form-input
                        autocomplete="on"
                        id="add-semester-penalty_duration"
                        type="number"
                        min="30"
                        :disabled="semester.penalty == 0"
                        v-model="semester.penalty_duration"
                        :state="
                          semester.penalty != 0 && errors.length > 0
                            ? false
                            : null
                        "
                      />
                      <small class="text-danger" v-if="semester.penalty != 0">{{
                        errors[0]
                      }}</small>
                    </validation-provider>
                  </b-form-group>

                  <b-form-group
                    label=" * قیمت مورد نظر را وارد کنید (تومان)"
                    label-for="add-semester-amount"
                    class="mb-1"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="amount"
                      vid="amount"
                      rules="required"
                    >
                      <b-form-input
                        autocomplete="on"
                        id="add-semester-amount"
                        type="number"
                        min="0"
                        v-model="semester.amount"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>

                  <b-form-checkbox
                    v-model="semester.percentage"
                    name="check-isCustomPrice"
                    switch
                    inline
                    :uncheckedValue="0"
                    :value="1"
                  >
                    {{
                      semester.percentage
                        ? "نوع تخفیف درصد (٪)"
                        : " نوع تخفیف مقدار (تومان) "
                    }}
                  </b-form-checkbox>
                  <b-form-group
                    label=" * تخفیف"
                    label-for="add-semester-rebate"
                    class="my-1"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="rebate"
                      vid="rebate"
                      rules="required"
                    >
                      <b-form-input
                        autocomplete="on"
                        id="add-semester-rebate"
                        v-model="semester.rebate"
                        class="mb-1"
                        type="number"
                        min="0"
                        :max="semester.percentage ? '100' : ''"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <hr class="my-1" />
                  <div class="d-flex my-2 w-100 justify-content-between">
                    <span>قیمت نهایی</span>
                    <span>{{ numberWithCommas(finalAmount) }} تومان</span>
                  </div>
                </b-col>
              </b-row>
              <hr class="my-2" />
              <b-row>
                <b-col>
                  <faq :faqs="semester.faqs" v-model="semester.faqs" />
                </b-col>
              </b-row>
              <hr class="my-2" />

              <b-row>
                <b-col>
                  <b-form-group
                    label="توضیحات مختصر"
                    label-for="add-semester-brief_description"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="brief_description"
                      vid="brief_description"
                    >
                      <editor
                        v-model="semester.brief_description"
                        :content="semester.brief_description"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr class="my-2" />

              <b-row>
                <b-col>
                  <b-form-group
                    label="توضیحات"
                    label-for="add-semester-description"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="description"
                      vid="description"
                    >
                      <editor
                        v-model="semester.description"
                        :content="semester.description"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col cols="12" md="4" xl="3" class="invoice-actions mt-md-0 mt-2">
            <b-card>
              <b-form-group
                label="انتخاب بنر برای ترم"
                label-for="add-semester-courses"
              >
                <validation-provider
                  #default="{ errors }"
                  name="courses"
                  vid="courses"
                  class="d-flex justify-content-start align-items-center w-100"
                >
                  <upload-file
                    class="w-100"
                    @uploadImage="uploadImage"
                    :banner="semester.banner"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <hr class="my-2" />
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mb-75"
                block
                :disabled="invalid"
                type="submit"
              >
                {{ $route.params.id ? "ویرایش ترم" : "ایجاد ترم" }}
              </b-button>
              <b-button
                :to="{ name: 'add-course' }"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="mb-75"
                block
              >
                ایجاد دوره
              </b-button>
              <b-button
                :to="{ name: 'semesters' }"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                block
              >
                برگشت به لیست ترم ها
              </b-button>
            </b-card>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>

    <loader :loading="loading" />
  </section>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BLink,
  BButton,
  BForm,
  BBadge,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BFormTextarea,
  BImg,
  BCard,
  BCardTitle,
  BFormFile,
  BCardText,
  BModal,
  BListGroupItem,
} from "bootstrap-vue";
import { required } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import Editor from "@/@core/components/editor/Editor.vue";
import Loader from "@/@core/components/loader/Loader.vue";
import SelectBox from "@/@core/components/select-box/SelectBox.vue";
import UploadFile from "@/@core/components/upload-file/UploadFile.vue";
import draggable from "vuedraggable";
import Roadmaps from "./Roadmaps.vue";
import Faq from "@core/components/faq/Faq.vue";
export default {
  components: {
    BRow,
    BImg,
    BCol,
    BLink,
    BBadge,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    BFormTextarea,
    BFormFile,
    BModal,
    BCard,
    Loader,
    SelectBox,
    Editor,
    UploadFile,
    BListGroupItem,
    draggable,
    Roadmaps,
    Faq,
  },
  directives: {
    Ripple,
  },
  computed: {
    finalAmount() {
      let finalAmount = 0;
      if (this.semester.percentage) {
        finalAmount =
          Number(this.semester.amount) -
          (Number(this.semester.amount) * Number(this.semester.rebate)) / 100;
      } else {
        finalAmount =
          Number(this.semester.amount) - Number(this.semester.rebate);
      }

      return finalAmount > 0 ? String(parseInt(finalAmount)) : "0";
    },
  },
  watch: {
    penalty(val) {
      this.semester.penalty = val;
      if (val == 0) {
        this.semester.penalty_duration = "";
      }
    },
  },
  data() {
    return {
      penalty: 0,
      semester: {
        name: "",
        description: "",
        brief_description: "",
        duration: "",
        amount: "",
        rebate: "",
        penalty_duration: "",
        penalty: 0,
        percentage: 0,
        separate: 0,
        active: 0,
        default: 0,
        unavailable_at: "",
        available_at: "",
        ended_at: "",
        started_at: "",
        banner: "",
        roadmaps: [],
        faqs: [],
        students: [],
      },
      loading: false,
      required,
    };
  },
  created() {
    if (this.$route.params.id) {
      this.getSemester();
    }
  },

  methods: {
    uploadImage(e) {
      this.semester.banner = e;
    },
    async getSemester() {
      this.loading = true;
      try {
        const { data } = await this.$http.get(
          `/panel/semesters/${this.$route.params.id}?includes=roadmaps,faqs`
        );
        await Object.keys(data.data).map((item) => {
          item == "active"
            ? (this.semester[item] = data.data[item] ? 1 : 0)
            : item == "default"
            ? (this.semester[item] = data.data[item] ? 1 : 0)
            : item == "percentage"
            ? (this.semester[item] = data.data[item] ? 1 : 0)
            : item == "penalty"
            ? (this[item] = data.data[item] ? 1 : 0)
            : item == "penalty_duration"
            ? data.data["penalty"]
              ? (this.semester[item] = data.data[item])
              : (this.semester[item] = "")
            : item == "separate"
            ? (this.semester[item] = data.data[item] ? 1 : 0)
            : item == "roadmaps"
            ? (this.semester[item] = data.data[item].roadmaps.map((item) => {
                return {
                  id: item.item_id,
                  vip: item.vip ? 1 : 0,
                  type: item.item_type,
                };
              }))
            : item == "students"
            ? (this.semester[item] = data.data[item].students)
            : item == "available_at"
            ? (this.semester[item] = this.calcDate(data.data[item]))
            : item == "unavailable_at"
            ? (this.semester[item] = this.calcDate(data.data[item]))
            : item == "started_at"
            ? (this.semester[item] = this.calcDate(data.data[item]))
            : item == "ended_at"
            ? (this.semester[item] = this.calcDate(data.data[item]))
            : item == "faqs"
            ? (this.semester[item] = data.data[item].faqs)
            : (this.semester[item] = data.data[item]);
        });
      } catch (err) {}
      this.loading = false;
    },
    semesterForm() {
      this.$refs.semesterForm.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          const semester = await { ...this.semester };
          try {
            this.formData = await new FormData();
            await Object.keys(semester).map((item, index) => {
              if (item == "available_at" && semester[item]) {
                semester[item] = this.toGorgian(semester[item]);
              }
              if (item == "unavailable_at" && semester[item]) {
                semester[item] = this.toGorgian(semester[item]);
              }
              if (item == "started_at" && semester[item]) {
                semester[item] = this.toGorgian(semester[item]);
              }
              if (item == "ended_at" && semester[item]) {
                semester[item] = this.toGorgian(semester[item]);
              }
              if (item == "faqs" && semester[item]) {
                semester[item] = semester[item].map((item) => {
                  return {
                    id: item.id,
                    active: item.active ? 1 : 0,
                    question: item.question,
                    answer: item.answer,
                  };
                });
              }
              if (
                item == "banner" &&
                semester[item] instanceof File === false
              ) {
                semester[item] = "";
              }
              if (item == "roadmaps" && semester[item]) {
                semester[item] = semester[item].map((item, index) => {
                  return {
                    id: item.id,
                    vip: item.vip,
                    sort: index + 1,
                    type: item.type,
                  };
                });
              }
              this.setFormData(semester[item], index, item);
            });

            if (this.$route.params.id) {
              const { data } = await this.$http.post(
                `/panel/semesters/${this.$route.params.id}`,
                this.formData,
                {
                  params: {
                    _method: "put",
                  },
                }
              );
              await this.getSemester();
            } else {
              const { data } = await this.$http.post(
                `/panel/semesters`,
                this.formData
              );
              this.penalty = 0;
              this.semester = {
                name: "",
                description: "",
                brief_description: "",
                duration: "",
                amount: "",
                rebate: "",
                percentage: 0,
                penalty_duration: "",
                penalty: 0,
                separate: 0,
                active: 0,
                default: 0,
                unavailable_at: "",
                available_at: "",
                banner: "",
                roadmaps: [],
                faqs: [],
                students: [],
              };
            }
            this.loading = false;
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: `اطلاعات شما با موفقیت ثبت شد.`,
                  icon: "CoffeeIcon",
                  variant: "success",
                },
              },
              { position: "bottom-right" }
            );
          } catch (err) {
            this.loading = false;
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: "مشکلی پیش آمده است",
                  icon: "InfoIcon",
                  variant: "danger",
                },
              },
              { position: "bottom-right" }
            );
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
.vpd-input-group {
  .vpd-icon-btn {
    margin-bottom: 0;
  }
  .form-control {
    border-radius: 0;
  }
}
</style>
